export * from '@discoverer/fuse/components/fullscreen/fullscreen.component';
export * from '@discoverer/fuse/components/fullscreen/fullscreen.module';
export * from '@discoverer/fuse/components/fullscreen/fullscreen.types';
